<template>
  <div>
    <TitlePage :title="$t('permissions')"></TitlePage>

    <v-layout wrap>
      <v-container fluid>
        <template v-for="role of roles" v-if="roles.length > 0">
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-subheader><strong>{{getName(role.name)}}</strong></v-subheader>
            </v-col>
            <v-col cols="12" sm="3" md="3" v-for="(module,index) in permissions.modules" :key="'module'+index" class="ma-0 pl-2 pr-2 pt-0 pb-0">
              <v-checkbox :label="$t(module)" color="primary" hide-details dense :value="module" v-model="role.permissions"/>
            </v-col>
          </v-row>
          <v-divider class="mt-10"/>
        </template>
      </v-container>

      <v-flex md12 class="d-flex pt-5">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-2 d-flex">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="save" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "Permissions",
  components: {TitlePage},
  data() {
    return {
      permissions:{
        modules:[]
      },
      roles:[],
    };
  },
  async created(){
    this.setLoading(true);
    let result = await this.getList();
    this.permissions.modules = result.permissions.modules;
    this.roles = result.role;
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'getList': 'permissions/getList',
      'updateItem': 'permissions/permissionUpdate'
    }),
    getName(name){
      switch (name) {
        case "admin":
          return this.$t('adminsCenter')
        case "collaborator":
          return this.$t('collaborator')
        default:
          return name
      }
    },
    async save() {
      this.setLoading(true);
      try {
        const promises = this.roles.map(role => this.updateItem(role));
        const results = await Promise.all(promises);

        const allSuccess = results.every(res => res && res.success);

        this.setNotification({
          active: true,
          color: allSuccess ? 'success' : 'error',
          mode: 'multi-line',
          text: allSuccess ? this.$t('updateSuccess') : this.$t('updateError')
        });

      } catch (error) {
        console.error('[Permissions Save Error]:', error);
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t('unexpectedError')
        });
      } finally {
        this.setLoading(false);
      }
    }

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>